/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Section_CountryInputs */

const en_admin_funnel_section_country = /** @type {(inputs: Admin_Funnel_Section_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By first-touch country`)
};

/**
* | output |
* | --- |
* | "By first-touch country" |
*
* @param {Admin_Funnel_Section_CountryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_section_country = /** @type {((inputs?: Admin_Funnel_Section_CountryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Section_CountryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_section_country(inputs)
});
export { admin_funnel_section_country as "admin.funnel.section.country" }